import React from 'react'
import PropTypes from 'prop-types'

import { Link } from '@aok/ui-elements'
import { Phone } from '@aok/icon-functional'

const OfferSearchPhone = ({ phoneNumber, className }) => {
  return (
    <div className="flex gap-x-8 items-start justify-start">
      <Phone className="w-16 h-16 text-586167 fill-current shrink-0 mt-3" />
      <Link className={className} href={`tel:${phoneNumber}`} title={phoneNumber} variant="structure" />
    </div>
  )
}

OfferSearchPhone.propTypes = {
  phoneNumber: PropTypes.string,
  className: PropTypes.string,
}

OfferSearchPhone.defaultProps = {
  className: '',
}

export default OfferSearchPhone
